
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { moneyFormatter } from '../../utils/helpers'
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import CKAutocomplete from 'component/element/CKAutocomplete'
import { DropdownButton, ButtonToolbar, Button, MenuItem, OverlayTrigger, Tooltip, Col, Row, FormGroup, FormControl, ControlLabel, InputGroup, Label } from 'react-bootstrap'
import SearchCarButton from 'component/element/SearchCarButton'
import EditableTD from './EditableTD'
import SupplierPageModal from '../po/SupplierPageModal'
import PODocStore from 'stores/PODocStore'
import WorkdocStore from 'stores/WorkdocStore'
import AutopartStore from 'stores/AutopartStore'
import IframeModal from 'component/element/IframeModal'
import Lightbox from 'react-images-extended';
import DatePicker from 'component/element/DatePicker'
import PurchaseOrderNewDocModal from 'view/po/PurchaseOrderNewDocModal'
import './priceCompare.css'
const NotificationSystem = require('react-notification-system');
// const DEFAULT_ROW = 10
class PriceCompareDoc extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      data:{doc:this.initDoc(),itemlist:[]},
      showModal:false,
      car_registration_no_list:[],
      showCar:false,
      docNo:'',
      options:[],
      showPoDoc:false,
      customerList:[],
      dataImg:{files:[]},
      currentImage:0,
      lightboxIsOpen:false,
      images:[]
    }
  }

  componentDidMount() {
    // this.loadPriceCompare()
    this._notificationSystem = this.refs.notificationSystem
  }

  initDoc() {
    return {
      pricecompare_no:"",request_by:"",response_by:"",work_no:"",description:"",car_detail:"",car_registration_no:"",remark:"",amount:"",userid:"",added_date:"",seq_no:""
    }
  }

  newValShop(shopList) {
    shopList = JSON.parse(JSON.stringify(shopList))
    if (shopList.length>0) {
      shopList = shopList.map((item,index)=>{
        item.oldPartPrice = 0
        item.originalPrice = 0
        item.similarPrice = 0
        return item
      })
      return shopList
    } else {
      return []
    }
  }

  newEmptyRow(number) {
    let {data} = this.state
    return new Array(number).fill(null).map((item, index) => {
      let NUMBER = data.itemlist.length===0?'1':(data.itemlist.length+1).toString()
      return {
        amount: "0",
        approval_price: "",
        bf_pricecompare_item_id: "",
        detail: "",
        itemnum: "",
        part_from: "",
        part_type: "originalPrice",
        pricecompare_no: "",
        price_on_shop: [],
        price_per_unit: "",
        quantity: "",
        ref_po_no: null,
        ref_work_no: null,
        selectedPrice: "",
        selectedShopId: "",
        seq: NUMBER,
        shopList: (data.itemlist.length>0?this.newValShop(data.itemlist[0].shopList):[])
      }
    })
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }
    
  loadCarRegistrationNo(doc) {
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - this.car_info_timestmap)>2000){
      WorkdocStore.loadCarRegistrationNoWithWork(doc.car_registration_no,(result)=> {
        let car = result.data.map((element,index) => {
          return Object.assign({id: element.Value,label: element.Name},element)
        });
        this.setState({car_registration_no_list:car})
        this.car_info_timestmap =  Date.now()
      })
    }
  }

  loadNewPriceCompare(completeFunc=undefined) {
    let that = this
    this.loadWorkdocAutocompleteOfficer()
    PODocStore.loadNewPriceCompareDoc(function (result) {
      let data = result.data
      data.itemlist = data.itemlist.map((item,index)=>{
        item = Object.assign({approval_price:''}, item)
        return item
      })
      that.setState({ data: data, docNo:data.doc.pricecompare_no },()=>{
        if (completeFunc!==undefined)
          completeFunc(data.doc)
      })
    }, function () {

    })
  }

  loadPriceCompare(docNo,completeFunc=undefined) {
    let that = this
    this.loadWorkdocAutocompleteOfficer()
    PODocStore.loadPriceCompareDoc(docNo,function (result) {
      let data = result.data
      data.itemlist = data.itemlist.map((item,index)=>{
        item = Object.assign({approval_price:''}, item)
        return item
      })
      that.setState({ data: data, docNo:docNo },()=>{
        that.loadFupPriceCompare()
        if (completeFunc!==undefined)
          completeFunc(data)
      })
    }, function () {

    })
  }

  renderFreezeFooter() {
    if (this.state.data.itemlist === null || typeof this.state.data.itemlist === 'undefined')
      return

    const totalUnitPrice = this.state.data.itemlist.reduce((total, partItem) => (
      total + partItem.approval_price * partItem.quantity * 1
    ), 0)

    return (
      <tr>
        <th className='text-center' colSpan={3}>ยอดสั่งซื้อ</th>
        <th className='text-right bg-yellow'>{moneyFormatter.format(totalUnitPrice)}</th>
      </tr>
    )
  }

  updateUnitPrice(itemnum, newUnitPrice) {
    const newPartList = this.state.data.itemlist.map((partItem) => {
      if (partItem.itemnum === itemnum)
        partItem.unitPrice = newUnitPrice
      return partItem
    })

    this.setState((prevState) => {
      prevState.data.itemlist = newPartList
      return {
        data: prevState.data
      }
    })
  }

  renderMenuItemChildren(result, props) {
    // console.log(props)
    return (
      <div>{result.label}</div>
    )
  }

  onUnitPriceInputChange(partItem, inputValue) {
    if (isNaN(inputValue)) {
      // console.log(inputValue)
      const refName = 'unitPrice:' + partItem.itemnum
      this[refName].getInstance().clear()
      // this.updateUnitPrice(partItem.itemnum, 0)
    }
  }

  onUnitPriceTypeAheadBlur(partItem, e) {
    // console.log('onUnitPriceTypeAheadBlur', e.target)
    if (e.target.value * 1 !== partItem.unitPrice) {
      this.updateUnitPrice(partItem.itemnum, e.target.value * 1)
      // this.updateUnitPrice(partItem.itemnum, partItem.unitPrice * 1)
    }

    // this[partItem.itemnum].getInstance()._updateText(partItem.unitPrice)
    // console.log(this[partItem.itemnum].getInstance())
  }

  onUnitPriceSelectChange(itemnum, selectedItems) {
    if (selectedItems.length === 0) return
    if (isNaN(selectedItems[0].id))
      this.updateUnitPrice(itemnum, 0)
    else
      this.updateUnitPrice(itemnum, selectedItems[0].id * 1)
  }


  renderUnitPrice(partItem) {
    const percents = [0.15, 0.20, 0.30]
    const selectedShop = partItem.shopList.filter((shop) => shop.shopId === partItem.selectedShopId)
    const price =
      partItem.selectedPrice !== '' && selectedShop.length > 0
        ? selectedShop[0][partItem.selectedPrice]
        : partItem.unitPrice

    const prices =
      partItem.selectedPrice !== ''
        ? percents.map((percent) => Math.round(price + price * percent))
        : []
    const options = prices.map((thePrice, i) => (
      {
        id: thePrice + '',
        label: moneyFormatter.format(thePrice) + '(' + percents[i] * 100 + '%)'
      }
    ))

    const refName = 'unitPrice:' + partItem.itemnum
    return (
      <Typeahead
        ref={(ta) => { this[refName] = ta }}
        selected={[(partItem.unitPrice?partItem.unitPrice:'0') + '']}
        style={{ textAlign: 'right' }}
        bsSize="sm"
        allowNew={true}
        newSelectionPrefix="ราคา:"
        emptyLabel="พิมพ์ราคาใหม่"
        labelKey={'id'}
        // placeholder={partItem.unitPrice + ''}
        filterBy={(option, text) => {
          return option.id
        }}
        options={options}
        onChange={this.onUnitPriceSelectChange.bind(this, partItem.itemnum)}
        onBlur={this.onUnitPriceTypeAheadBlur.bind(this, partItem)}
        renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}
        onInputChange={this.onUnitPriceInputChange.bind(this, partItem)}

      />
    )
  }

  /* onQuantityChange(selectedPartItem, e) {
    const newPartList = this.state.data.itemlist.map((partItem) => {
      if (partItem.itemnum === selectedPartItem.itemnum) {
        partItem.quantity = e.target.value * 1
        return partItem
      }
      return partItem
    })
  
    this.setState((prevState) => {
      prevState.data.itemlist = newPartList
      return {
        data: prevState.data
      }
    })
  } */

  updateQuantity(selectedPartItem, newQuantity, i) {
    let {data} = this.state
    let amount = this.getAmountPerRow(i)
    data.itemlist[i].amount = amount
    data.itemlist[i].quantity = newQuantity
    this.setState({data:data})
  }

  onNewQuantityChange(selectedPartItem, i, selectedItems) {
    if (selectedItems.length === 0) return
    const newQuantity = selectedItems[0].id
    this.updateQuantity(selectedPartItem, newQuantity, i)
  }

  updateApprovalPrice(selectedPartItem, newApprovalPrice, i) {
    let {data} = this.state
    let amount = this.getAmountPerRow(i)
    data.itemlist[i].amount = amount
    data.itemlist[i].approval_price = newApprovalPrice
    this.setState({data:data})
  }

  onApprovalPriceChange(selectedPartItem,i,e) {
    let newApprovalPrice = e.target.value
    this.updateApprovalPrice(selectedPartItem,newApprovalPrice,i)
  }

  onQuantityTypeAheadBlur(selectedPartItem, i, e) {
    const newQuantity = e.target.value
    this.updateQuantity(selectedPartItem, newQuantity, i)
  }

  renderNewQuantity(partItem,ii) {
    const prices = new Array(10).fill(null).map((val, index) => index + 1)
    const options = prices.map((thePrice, i) => (
      { id: thePrice + '', label: thePrice + '' }
    ))

    return (
      <Typeahead
        selected={[partItem.quantity + '']}
        // ref={(ta) => { this[refName] = ta }}
        // style={{ textAlign: 'right' }}
        bsSize="sm"
        allowNew={true}
        newSelectionPrefix="จำนวน:"
        // emptyLabel="จำนวน"
        labelKey={'id'}
        // placeholder={partItem.unitPrice + ''}
        filterBy={(option, text) => {
          return option
        }}
        options={options}
        onChange={this.onNewQuantityChange.bind(this, partItem, ii)}
        onBlur={this.onQuantityTypeAheadBlur.bind(this, partItem, ii)}
      // renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}
      />
    )
  }

  renderApprovalPrice(partItem,i) {
    return(
      <FormControl
        className='text-right'
        style={{height:'30px'}}
        onChange={this.onApprovalPriceChange.bind(this, partItem, i)}
        value={partItem.approval_price}
      />
    )
  }

  getAmountPerRow(i) {
    let {data} = this.state
    let sum = 0
    let quantity = (data.itemlist[i].quantity===''||data.itemlist[i].quantity===null||data.itemlist[i].quantity===undefined||isNaN(data.itemlist[i].quantity)?0:data.itemlist[i].quantity*1)
    let approval_price = (data.itemlist[i].approval_price===''||data.itemlist[i].approval_price===null||data.itemlist[i].approval_price===undefined||isNaN(data.itemlist[i].approval_price)?0:data.itemlist[i].approval_price*1)
    sum = quantity*approval_price
    return sum
  }

  /* renderQuantity(partItem) {
    return (
      <FormControl
        value={partItem.quantity}
        bsSize="sm"
        className='text-center'
        onChange={this.onQuantityChange.bind(this, partItem)}
      />
    )
  } */

  onSearch(index, query) {
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1, query, function (result) {
      //console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item, index) => {
        return { 
          id: item.itemnum, 
          productCode: item.productcode, 
          itemnum: item.itemnum, 
          categoryName: item.cat_name, 
          detail: item.description, 
          pricePerUnit: item.price_per_unit, 
          unit: item.unit, 
          stock_type: item.stock_type,
          container_quantity: item.container_quantity,
          container_unit: item.container_unit,
          is_container: item.is_container,
          quantity_per_container_unit: item.quantity_per_container_unit,
          quantity: item.quantity
        }
      })
      that.setState({ options: options })
    })
    //this.setState({options:options})
  }

  onTypeaheadChange(index, option) {
    let {data} = this.state
    if (option.length === 1) {
      data.itemlist[index].detail = option[0].detail
      data.itemlist[index].quantity = 1
      data.itemlist[index].price_per_unit = ''
      data.itemlist[index].amount = ''
      data.itemlist[index].approval_price = ''
      if (option[0].itemnum !== undefined) {
        data.itemlist[index].itemnum = option[0].itemnum
      }
    }
    this.setState({data:data})
  }

  onTypeaheadInputChange(index,query){
    let {data} = this.state
    data.itemlist[index]['detail'] = query
    this.setState({data:data})
  }

  _renderMenuItemChildren(option, props, index) {
    if (option.pricePerUnit > 0) {
      return (
        <div key={option.id}>
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    } else {
      return (
        <div key={option.id}>
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderFreezedBody() {
    if (typeof this.state.data.itemlist === 'undefined') return
    // const tdStyle = { maxheight: '30px' }
    if (this.state.data.itemlist.length===0) {
      return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    }
    return( 
      this.state.data.itemlist.map((partItem, i) => {
        return(
          <tr key={i}>
            <td className='text-center' style={{ width: '80px',verticalAlign:'middle' }}>{i + 1}</td>
            <td className='data-column col-price-compare text-left'>
              <AsyncTypeahead
                allowNew={false}
                multiple={false}
                newSelectionPrefix={'เพิ่มรายการใหม่ : '}
                promptText={'พิมพ์รายการเพื่อค้นหา...'}
                searchText={'กำลังค้นหา...'}
                selected={[{ detail: partItem.detail }]}
                options={this.state.options}
                labelKey="detail"
                onSearch={this.onSearch.bind(this,i)}
                onChange={this.onTypeaheadChange.bind(this,i)}
                onInputChange={this.onTypeaheadInputChange.bind(this,i)}
                placeholder=""
                renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
              />
            </td>
            <td className='text-center' style={{ width: '80px' }}>{this.renderNewQuantity(partItem,i)}</td>
            {/* <td style={{ width: '120px' }}>{this.renderApprovalPrice(partItem,i)}</td> */}
            <td style={{ width: '120px',verticalAlign:'middle' }} className='text-right'>{this.getNumberFormat(this.getAmountPerRow(i))}</td>
          </tr>
        )  
      })  
    )
  }

  renderFreezedTable() {
    const titles = [
      {
        title: 'ลำดับ',
        style: { width: '50px', maxWidth: '50px' },
        className: 'text-center'
      },
      {
        title: 'รายการ',
        style: { height: '86px', width: '200px', minWidth: '200px' },
        className: 'text-center'
      },
      {
        title: 'จำนวน',
        style: { width: '20px' },
        className: 'text-center'
      },
      // {
      //   title: 'ราคาอนุมัติ/ชิ้น',
      //   style: { width: '100px' },
      //   className: 'text-center'
      // },
      {
        title: 'ราคารวม',
        style: { width: '100px' },
        className: 'text-center'
      }
    ]

    // 78px from value of two <thead> in ScrollableTable
    // const detailStyle = {
    //   height: '78px'
    //   // minWidth: '250px'
    // }
    const header = titles.map((eachTitle, tid) => (
      <th
        key={tid}
        className={eachTitle.className}
        style={eachTitle.style}
      >
        {eachTitle.title}
      </th>
    ))
    return (
      <table className='table table-responsive table-hover table-bordered-solid freezed-table' style={{marginBottom:'0'}}>
        <thead>
          <tr>
            {header}
          </tr>
        </thead>
        <tbody>
          {this.renderFreezedBody()}
        </tbody>
        <tfoot>
          {this.renderFreezeFooter()}
        </tfoot>
      </table>
    )
  }

  // onUnitPriceInputTextEnter(itemnum, shopId, priceType, bf, newPrice) {
  //   const newPartList = this.state.data.itemlist.map((partItem) => {
  //     if ((partItem.itemnum === itemnum&&partItem.bf_pricecompare_item_id === bf)||(partItem.bf_pricecompare_item_id === bf)) {
  //       partItem.shopList.forEach((shop) => {
  //         if (shop.shopId === shopId)
  //           shop[priceType] = newPrice * 1
  //       })
  //     }
  //     return partItem
  //   })
  //   this.setState((prevState) => {
  //     prevState.data.itemlist = newPartList
  //     return {
  //       data: prevState.data
  //     }
  //   })
  // }

  onUnitPriceInputTextEnter(itemnum, shopId, priceType, bf, seq, newPrice) {
    const newPartList = this.state.data.itemlist.map((partItem) => {
      if (
        (partItem.itemnum===''&&itemnum===''&&partItem.bf_pricecompare_item_id===''&&bf===''&&seq===partItem.seq)||
        ((partItem.itemnum!==''&&itemnum!==''&&partItem.bf_pricecompare_item_id!==''&&bf!=='')&&((partItem.itemnum===itemnum&&partItem.bf_pricecompare_item_id===bf)||(partItem.bf_pricecompare_item_id===bf)))) {
        partItem.shopList.forEach((shop) => {
          if (shop.shopId === shopId)
            shop[priceType] = newPrice * 1
        })
      }
      return partItem
    })
    this.setState((prevState) => {
      prevState.data.itemlist = newPartList
      return {
        data: prevState.data
      }
    })
  }

  // updatePartList(itemnum, shopId, priceType, bf) {
  //   // const currentData = JSON.parse(JSON.stringify(this.state.data))
  //   const newPartList = this.state.data.itemlist.map((partItem) => {
  //     // if click on selected price
  //     if (
  //       (partItem.itemnum === itemnum && partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_pricecompare_item_id === bf)
  //       ||
  //       (partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_pricecompare_item_id === bf)
  //     ) {
  //       partItem.selectedPrice = ''
  //       partItem.selectedShopId = ''
  //       return partItem
  //     }

  //     // click on different one
  //     if ((partItem.itemnum === itemnum && partItem.bf_pricecompare_item_id === bf) || (partItem.bf_pricecompare_item_id === bf)) {
  //       partItem.selectedShopId = shopId
  //       partItem.selectedPrice = priceType
  //     }
  //     return partItem
  //   })

  //   this.setState((prevState) => {
  //     prevState.data.itemlist = newPartList
  //     return {
  //       data: prevState.data
  //     }
  //   })
  // }

  updatePartList(itemnum, shopId, priceType, bf, seq) {
    // const currentData = JSON.parse(JSON.stringify(this.state.data))
    const newPartList = this.state.data.itemlist.map((partItem) => {
      // if click on selected price
      if (
        (seq===partItem.seq&&partItem.itemnum===''&&itemnum===''&&partItem.bf_pricecompare_item_id===''&&bf===''&&partItem.selectedShopId === shopId && partItem.selectedPrice === priceType)
        ||
        ((partItem.itemnum!==''&&itemnum!==''&&partItem.bf_pricecompare_item_id!==''&&bf!=='')&&((partItem.itemnum === itemnum && partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_pricecompare_item_id === bf)
        ||
        (partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_pricecompare_item_id === bf)))
      ) {
        partItem.selectedPrice = ''
        partItem.selectedShopId = ''
        return partItem
      }
      
      // click on different one
      if (
        (seq===partItem.seq&&partItem.itemnum===''&&itemnum===''&&partItem.bf_pricecompare_item_id===''&&bf==='')
        ||
        ((partItem.itemnum!==''&&itemnum!==''&&partItem.bf_pricecompare_item_id!==''&&bf!=='')&&((partItem.itemnum === itemnum && partItem.bf_pricecompare_item_id === bf) || (partItem.bf_pricecompare_item_id === bf)))
      ) {
        partItem.selectedShopId = shopId
        partItem.selectedPrice = priceType
      }
      return partItem
    })

    this.setState((prevState) => {
      prevState.data.itemlist = newPartList
      return {
        data: prevState.data
      }
    })
  }

  onEditableTDClick(itemnum, shopId, priceType, bf, seq) {
    this.updatePartList(itemnum, shopId, priceType, bf, seq)
  }

  renderPartItem() {
    const priceColumns = ['originalPrice']

    return this.state.data.itemlist.map((partItem, pid) => {
      const tds = partItem.shopList.map((shop, sid) => (
        priceColumns.map((priceType, cid) => {
          const selected = (partItem.selectedShopId === shop.shopId && partItem.selectedPrice === priceType)
          const tdKey = pid * 10 + cid
          return (
            <EditableTD
              key={tdKey}
              value={shop[priceType]}
              selected={selected}
              tdStyle={{ minWidth: '90px', maxWidth: '90px' }}
              textInputStyle={{ textAlign: 'center', height: '30px' }}
              textDivStyle={{ textAlign: 'center', height: '30px', lineHeight: '30px', padding: '0' }}
              className={selected ? 'bg-yellow' : ''}
              onInputTextEnter={this.onUnitPriceInputTextEnter.bind(this, partItem.itemnum, shop.shopId, priceType, partItem.bf_pricecompare_item_id, partItem.seq)}
              onInputTextBlur={this.onUnitPriceInputTextEnter.bind(this, partItem.itemnum, shop.shopId, priceType, partItem.bf_pricecompare_item_id, partItem.seq)}
              onClick={this.onEditableTDClick.bind(this, partItem.itemnum, shop.shopId, priceType, partItem.bf_pricecompare_item_id, partItem.seq)}
              // onInputTextBlur={this.onUnitPriceInputTextEnter.bind(this, partItem.itemnum, shop.shopId, priceType)}
              // onDoubleClick={this.onEditableTDDoubleClick.bind(this, partItem.itemnum, partItem.selectedShopId, partItem.selectedPrice)}
            />
          )
        })
      ))

      return <tr key={pid}>{tds}</tr>
    })
  }

  renderScrollableFooter() {
    const totalShopPrice =
      this.state.data.itemlist.reduce((sumPriceShop, partItem) => {
        const selectedPriceOfShops =
          partItem.shopList.map((shop) => {
            if (shop.shopId === partItem.selectedShopId)
              return shop[partItem.selectedPrice]
            return 0
          })

        if (sumPriceShop.length === 0)
          return sumPriceShop.concat(selectedPriceOfShops)
        return sumPriceShop.map((eachSum, i) => (
          eachSum + selectedPriceOfShops[i]
        ))
      }, [])

    const tds =
      totalShopPrice.map((price, i) => (
        <th
          key={i}
          colSpan={1}
          className='text-center bg-yellow'
        >
          {moneyFormatter.format(price)}
        </th>
      ))

    return <tr>{tds}</tr>
  }

  onRemoveShopClick(shopIdToRemove) {
    const newPartList = this.state.data.itemlist.map((partItem) => {
      const newPartItem = JSON.parse(JSON.stringify(partItem))
      newPartItem.selectedPrice = ''
      newPartItem.selectedShopId = ''
      newPartItem.shopList = partItem.shopList.filter((shop) => shop.shopId !== shopIdToRemove)
      return newPartItem
    })

    this.setState((prevState) => {
      const newData = JSON.parse(JSON.stringify(prevState.data))
      newData.itemlist = newPartList
      return {
        data: newData
      }
    })
  }

  renderScrollableTable() {
    let {data} = this.state
    if (typeof data.itemlist === 'undefined'||data.itemlist.length===0) return
    const priceTitles = ['ราคาต่อหน่วย']
    const shopHeaders = this.state.data.itemlist[0].shopList.map((shop, i) => (
      <th
        key={i}
        className='text-center'
        colSpan={priceTitles.length}
        style={{position:'relative'}}
      >
        <div style={{
          // width:'100px',
          whiteSpace:'nowrap',
          paddingRight:'15px',
          // textOverflow:'ellipsis',
          // overflow:'hidden'
        }}>
          {shop.shopName}
        </div>
        <span
          style={{position:'absolute',right:'5px',top:'10px'}}
          className='remove-shop' // pull-right
          onClick={this.onRemoveShopClick.bind(this, shop.shopId)}
        >
          <FontAwesome
            name='close'
            style={{ color: 'LightBlue' }}
          />
        </span>
      </th>
    ))
    const priceHeaders = this.state.data.itemlist[0].shopList.map((shop, sid) => {
      return priceTitles.map((title, tid) => (
        <th
          key={sid * 10 + tid}
          className='text-center'
          style={{minWidth:'100px'}}
        >
          {title}
        </th>
      ))
    })

    return (
      <table className='table table-responsive table-hover table-bordered-solid freezed-table' style={{marginBottom:'0'}}>
        <thead>
          <tr>
            {shopHeaders}
          </tr>
          <tr>
            {priceHeaders}
          </tr>
        </thead>
        <tbody>
          {this.renderPartItem()}
        </tbody>
        <tfoot>
          {this.renderScrollableFooter()}
        </tfoot>
      </table>
    )
  }

  renderTable() {
    let {data} = this.state
    let shopMenu = []
    if (data.itemlist.length>0) {
      shopMenu = data.itemlist[0].shopList.map((item,index)=>{
        return item
      })
    }
    return (
      <div>
        <div className={data.itemlist.length===0||shopMenu.length===0?'col-lg-12 col-md-12 padding-none':'col-lg-5 col-md-12 padding-none'}>
          {this.renderFreezedTable()}
        </div>
        {data.itemlist.length>0&&shopMenu.length>0
        ?
        <div className='col-lg-7 col-md-12 padding-none display-overflow'>
          {this.renderScrollableTable()}
        </div>
        :''}
      </div>
    )
  }

  onMenuSelect(shop_id) {
    let {data} = this.state
    let shopList = [] 
    if (data.itemlist.length>0)
      shopList = data.itemlist[0].shopList
    let shop_name = ''
    let shopIndex = shopList.findIndex(x=>x.shopId===shop_id)
    if (shopIndex!==-1)
      shop_name = shopList[shopIndex].shopName
    let shopInfo = {shop_id:shop_id,shop_name:shop_name}  
    this.setState({showPoDoc:true})
    this.refs.poDocModal.getWrappedInstance().onLoadNewDoc(()=>{
      this.refs.poDocModal.getWrappedInstance().onSetSupplier(shopInfo)
      let itemlist = []
      data.itemlist.forEach((item,index)=>{
        if (item.selectedShopId===shop_id)
          itemlist.push(item)
      })
      this.refs.poDocModal.getWrappedInstance().onSetItemlist(itemlist)
    })
  }

  onAddShopClick(e) {
    this.setState({
      showModal: true
    })
  }

  onSupplierPageSelect(item) {
    let {data} = this.state
    if (data.itemlist.length === 0) {
      data.itemlist = data.itemlist.concat(this.newEmptyRow(1))
    }

    const newPartList = data.itemlist.map((partItem) => {
      const shopExisted = partItem.shopList.filter((shop) => shop.shopId === item.shop_id).length > 0
      if (shopExisted) return partItem

      // if it's new shop, add into shopList
      const newShopList = partItem.shopList.concat({
        shopId: item.shop_id,
        shopName: item.name,
        originalPrice: 0,
        similarPrice: 0,
        oldPartPrice: 0
      })
      const newPartItem = JSON.parse(JSON.stringify(partItem))
      newPartItem.shopList = newShopList
      return newPartItem
    })

    if (data.itemlist[0].shopList.length === newPartList[0].shopList.length) return
    this.setState((prevState) => {
      const newData = JSON.parse(JSON.stringify(prevState.data))
      newData.itemlist = newPartList
      return {
        data: newData
      }
    })
  }

  onSaveClick(){
    let {data,docNo} = this.state
    
    let postData = {doc:data.doc,itemlist:data.itemlist}
    PODocStore.savePriceCompareDoc(docNo,postData,(result)=>{
      if (result.status==='OK') {
        data.doc.seq_no = result.seq_no
        this.setState({data:data})
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'บันทึกรายการสำเร็จ',
          level:'info',
          position:'tc'        
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'บันทึกรายการไม่สำเร็จ',
        level:'error',
        position:'tc'        
      });
    })
  }

  onCloseClick(){
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  onTextChange(field,e) {
    let {data} = this.state
    data.doc[field] = (field==='added_date'?e:e.target.value)
    this.setState({data:data},()=>{
      if (field==='car_registration_no') {
        this.loadCarRegistrationNo(data.doc)
        if(data.doc[field]==='') {
          data.doc.car_detail = ''
          this.setState({data:data})
        }  
      }
    })
  }

  onTextSelect(key,e) {
    let {car_registration_no_list,data} = this.state
    if (key==='car_registration_no') {
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          data.doc.car_detail = item.car_info
          data.doc.work_no =  item.work_no
          if (data.doc.work_no===undefined)
            data.doc = Object.assign(data.doc, {work_no:item.work_no})
          else   
            data.doc.work_no =  item.work_no
          
          data.doc[key] = item.car_registration_no  
        }  
      })
    } else {
      data.doc[key] = e
    }
    this.setState({data:data})
  }

  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      let {data} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          data.doc.work_no =  item.work_no         
          data.doc.car_registration_no = item.car_registration_no       
          data.doc.car_detail = item.car_info       
          that.setState({data:data})
        }else{
          data.doc.work_no = ''
          data.doc.car_registration_no = ''
          data.doc.car_detail = 'ไม่พบทะเบียนรถ'
          that.setState({data:data})
        }
      })
    }
  }

  sortRowIndex(itemlist) {
    itemlist = itemlist.map((item,index)=>{
      item.seq = (index+1).toString()
      
      return item
    })
    return itemlist
  }

  onRowAdd(number) {
    let {data} = this.state
    data.itemlist = data.itemlist.concat(this.newEmptyRow(number))
    data.itemlist = this.sortRowIndex(data.itemlist)
    this.setState({data:data})
  }

  onClearCar() {
    let {data} = this.state
    data.doc.work_no = ''
    data.doc.car_registration_no = ''
    data.doc.car_detail = ''
    this.setState({data:data})
  }

  onCarSearchSelect(e) {
    let {data} = this.state
    data.doc.work_no = e.work_no
    data.doc.car_registration_no = (typeof e.car_registration_no!=='undefined'?e.car_registration_no:e.Value)
    data.doc.car_detail = e.car_info
    this.setState({data:data})
  }

  onPoDocModalHide() {
    this.setState({showPoDoc:false})
  }

  onUploadClick(e) { 
    let {docNo} = this.state
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = 'https://demo2.bigfix.co/okorat/fup/po.html?pc='+docNo
    } else {
      url = './fup/po.html?pc='+docNo
    }
    this.refs.iframeUpload.loadUrl(url)
  }

  loadFupPriceCompare() {
    let {docNo} = this.state
    PODocStore.loadFupPriceCompare(docNo,'pricecompare_images','pc',(result)=>{
      this.setState({dataImg:result.data})
    })
  }

  onUpImgHide(e) {
    this.loadFupPriceCompare()
  }

  onImgClick(index,e) {
    let {images,dataImg} = this.state
    dataImg.files.forEach(element => {
      images.push({
        src: element.url,
        thumbnail: element.thumbnailUrl,
        srcset: [
          element.url,
        ],
        caption: element.name
      })
    })  
    
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
      images:images
    });
  }

  onClickImage() {
    let {dataImg} = this.state
    if (this.state.currentImage === 0) {
      this.onClickNext()
    } else if (this.state.currentImage === dataImg.files.length-1) {
      this.onClickPrevious()
    }  
  }

  onClickNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  onClickPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  onCloseLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      images:[]
    });
  }
  
  renderToolbar() {
    let {data} = this.state
    let shopMenu = []
    if (data.itemlist.length>0) {
      shopMenu = data.itemlist[0].shopList.map((shop, i) => (
        <MenuItem key={shop.shopId} eventKey={shop.shopId}>
          {shop.shopName}
        </MenuItem>
      ))
    }
    const title = (<span><FontAwesome name='shopping-cart' /> สร้างรายการสั่งซื้อ</span>)
    return (
      <div>
        <Button
          bsStyle="primary"
          onClick={this.onAddShopClick.bind(this)}
        >
          <FontAwesome name='plus' /> เพิ่มร้าน
        </Button>
        {' '}
        <DropdownButton disabled={shopMenu.length===0?true:false} bsStyle={'primary'} title={title} id={'create-purchase'} onSelect={this.onMenuSelect.bind(this)}>
          {shopMenu}
        </DropdownButton>
      </div>
    )
  }

  renderHeaderRow() {
    let {data,customerList} = this.state
    return(
      <div>
        <Row>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>ผู้ทำรายการ :</ControlLabel>
              <CKAutocomplete
                top={'-34px'}
                items={customerList}
                value={data.doc.userid?data.doc.userid:data.doc.request_by}
                onChange={this.onTextChange.bind(this, data.doc.userid?'userid':'request_by')}
                onSelect={this.onTextSelect.bind(this, data.doc.userid?'userid':'request_by')}
              />
            </FormGroup>
          </Col>
          <Col md={3} sm={3}>
            <FormGroup>
              <ControlLabel>ลงวันที่ :</ControlLabel>
              <DatePicker 
                  style={{ display: 'inline-block' }}
                  showIcon={true}
                  showFooter={true}
                  popPlacement='bottom'
                  buddhistEra
                  value={data.doc.added_date}
                  onChange={this.onTextChange.bind(this,'added_date')}
                  maxWidth={'100%'}
                />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          {/* <Col md={3} sm={3}>
              <FormGroup>
                <ControlLabel>ทะเบียนรถ : <Button bsSize='xs' onClick={this.onClearCar.bind(this)}><FontAwesome name='eraser' />&nbsp;เคลียร์ข้อมูลรถ</Button></ControlLabel>
                <InputGroup>
                  <CKAutocomplete
                        items={car_registration_no_list}
                        value={data.doc.car_registration_no!==null?data.doc.car_registration_no:''}
                        onKeyPress={this.onSearchCarKeyPress.bind(this)}
                        onChange={this.onTextChange.bind(this, 'car_registration_no')}
                        onSelect={this.onTextSelect.bind(this, 'car_registration_no')}

                      />
                      <InputGroup.Addon className="btn" onClick={()=>this.setState({showCar:true})}>
                    <FontAwesome name='search' />
                  </InputGroup.Addon>    
                </InputGroup>      
              </FormGroup>
          </Col> */}
          {/* <Col md={3} sm={3}>
              <FormGroup>
                <ControlLabel>ยี่ห้อรถ/รุ่นรถ</ControlLabel>
                <FormControl className='text-left' value={data.doc.brand_model} onChange={this.onTextChange.bind(this, 'brand_model')} />
              </FormGroup>
          </Col> */}
          {/* <Col md={3} sm={4}>
              <FormGroup>
                <ControlLabel>รายละเอียดรถ</ControlLabel>
                <h3 style={{margin:'0px'}}>
                  <Label bsStyle='default'>{data.doc.car_detail}</Label>
                </h3>
              </FormGroup>
          </Col> */}
          {/* <Col md={3} sm={4}>
              <FormGroup>
                <ControlLabel>ตั้งงบประมาณ (บาท)</ControlLabel>
                <FormControl className='text-right' value={data.doc.amount} onChange={this.onTextChange.bind(this, 'amount')} />
              </FormGroup>
          </Col> */}
          {/* <Col md={3} sm={4}>
              <FormGroup>
                <ControlLabel>ปีรถ</ControlLabel>
                <FormControl className='text-left' value={data.doc.year_series} onChange={this.onTextChange.bind(this, 'year_series')} />
              </FormGroup>
          </Col> */}
        </Row>
      </div>    
    )
  }

  renderRemark() {
    let { remark } = this.state.data.doc
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={3} sm={6}>
          <FormGroup>
            <ControlLabel>หมายเหตุ</ControlLabel>
              <FormControl autoComplete={false} value={remark} componentClass="textarea" style={{ width: '100%', height: '150px' }} onChange={this.onTextChange.bind(this, 'remark')} />
          </FormGroup>
        </Col>
        <Col md={9}>
          <Row>
            {this.renderImgZone()}
          </Row>  
        </Col>
      </Row>
    )
  }

  renderNewItemButton() {
    return (
      <div style={{ display: 'inline-flex' }}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 1)}><FontAwesome name='plus' />&nbsp;เพิ่มรายการ</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 10)}><FontAwesome name='plus' />&nbsp;เพิ่ม 10 รายการ</Button>
          <Button 
            className='btn btn-primary' 
            onClick={this.onUploadClick.bind(this)}
          >
            <FontAwesome name='file-image-o'/>&nbsp;ไฟล์รูปแนบ
          </Button>
        </ButtonToolbar>  
      </div>
    )
  }

  renderImgZone() {
    let {dataImg} = this.state
    if (dataImg.files.length>0) {
      return(
        dataImg.files.map((item, index) => {
          return(
            <Col key={index} className="col-md-15 template-download">
              <div className="thumb-box">
                <span className="preview" onClick={this.onImgClick.bind(this,index)}>
                  <a title="">
                    <img alt='' src={item.thumbnailUrl} className='img-auto-width' />
                  </a>
                </span>
                <div style={{display:'flex'}}>
                  <p className="name">
                    <a>{item.name}</a>
                  </p>
                </div>
                <div className="footer-box" style={{display:'flex'}}>
                  {item.createddate}
                </div>
              </div>
            </Col>   
          )       
        })
      )    
    } else {
      return(
        <div className="text-center">
          --ไม่มีรูปภาพ--
        </div>
      )
    }  
  }

  render() {
    const titile = 'เปรียบเทียบราคาทั่วไป'
    return (
      <div>
        <Box loading={this.state.loading}>
          <Box.Header className='text-center'>
            <Box.Title>{titile}</Box.Title>
          </Box.Header>
          <Box.Body>
            {this.renderHeaderRow()}
            <div className='text-right part-price-tool'>
              {this.renderToolbar()}
            </div>
            <div className='price-compare' style={{marginTop:'5px'}}>
              {this.renderTable()}
            </div>
            {this.renderNewItemButton()}
            {this.renderRemark()}     
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/> บันทึก</Button>
              <Button bsStyle='default' onClick={this.onCloseClick.bind(this)}><FontAwesome name='table'/> กลับหน้าตาราง</Button>
            </ButtonToolbar>
          </Box.Footer>
        </Box>
        <SupplierPageModal
              show={this.state.showModal}
              showNew={true}
              onHide={() => { this.setState({ showModal: false }) }}
              onSelect={this.onSupplierPageSelect.bind(this)}
        />
        <SearchCarButton
              showCarNo={true}
              show={this.state.showCar}
              onHide={()=>{this.setState({showCar:false})}}
              onSelect={this.onCarSearchSelect.bind(this)}
        />
        <PurchaseOrderNewDocModal 
          ref='poDocModal' 
          show={this.state.showPoDoc}
          onHide={this.onPoDocModalHide.bind(this)}
        />
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.state.images}
          isOpen={this.state.lightboxIsOpen}
          rotatable={true}
          zoomable={true}              
          onClickImage={this.onClickImage.bind(this)}
          onClickNext={this.onClickNext.bind(this)}
          onClickPrev={this.onClickPrevious.bind(this)}
          onClose={this.onCloseLightbox.bind(this)}
        />
        <IframeModal ref='iframeUpload' title={'อัพโหลดรูป'} modal={true} onUpImgHide={this.onUpImgHide.bind(this)}/>
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }
}

export default PriceCompareDoc



// WEBPACK FOOTER //
// ./src/view/pricecompare/PriceCompareDoc.js